import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.css']
})
// export class AnalyticsComponent implements OnInit {

//   loading = false;
//   analyticsEnabled = true;
//   analyticsMessage = '';

//   analyticsCards: any[] = [];

//   constructor(
//     private authService: AuthenticationService
//   ) {}

//   ngOnInit(): void {
//     this.getAnalytics();
//   }

//   getAnalytics() {

//     this.loading = true;

//     const helper = new JwtHelperService();

//     const token = localStorage.getItem('merchant_token');

//     if (!token) {
//       this.loading = false;
//       return;
//     }

//     const decoded: any = helper.decodeToken(token);

//     const merchantId = decoded.id;

//     this.authService.getMerchantAnalytics(merchantId).subscribe(

//       (res: any) => {

//         this.loading = false;

//         if (!res.analyticsEnabled) {
//     this.analyticsEnabled = false;
//     this.analyticsMessage = res.message;
//     return;
// }

//         const data = res.data;

//         this.analyticsCards = [
//           {
//             title: 'Profile Views',
//             value: data.profileViews??0,
//             icon: 'fas fa-eye',
//             color: '#3B82F6'
//           },
//           // {
//           //   title: 'Search Impressions',
//           //   value: data.searchImpressions??0,
//           //   icon: 'fas fa-search',
//           //   color: '#8B5CF6'
//           // },
//           {
//             title: 'Website Clicks',
//             value: data.websiteClicks??0,
//             icon: 'fas fa-globe',
//             color: '#10B981'
//           },
//           {
//             title: 'Phone Clicks',
//             value: data.phoneClicks??0,
//             icon: 'fas fa-phone',
//             color: '#F59E0B'
//           },
//           {
//             title: 'Directions Clicks',
//             value: data.directionsClicks??0,
//             icon: 'fas fa-map-marker-alt',
//             color: '#EF4444'
//           },
//           {
//             title: 'Up Ratings',
//             value: data.upratings??0,
//             icon: 'fas fa-thumbs-up',
//             color: '#06B6D4'
//           },
//           {
//             title: 'Down Ratings',
//             value: data.downratings??0,
//             icon: 'fas fa-thumbs-down',
//             color: '#EC4899'
//           },
//           {
//             title: 'Email Clicks',
//             value: data.emailClicks??0,
//             icon: 'fas fa-envelope',
//             color: '#14B8A6'
//           }
//           ,
//             {
//             title: 'Male Visitors',
//             value: data.maleVisitors??0,
//             icon: 'fas fa-male',
//             color: '#14B8A6'
//           }
//           ,
//             {
//             title: 'Female Visitors',
//             value: data.femaleVisitors??0,
//             icon: 'fas fa-female',
//             color: '#14B8A6'
//           }

//         ];

//       },
//       (error: any) => {

//         this.loading = false;

//         this.authService.successMessage(
//           error.error.message,
//           'error'
//         );

//       }

//     );

//   }

// }
export class AnalyticsComponent implements OnInit {

  loading = false;
  analyticsEnabled = true;
  analyticsMessage = '';

  analyticsCards: any[] = [];
  insightsData: any = null;   // NEW

  constructor(
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.getAnalytics();
    this.getInsights();   // NEW
  }

  getAnalytics() {

    this.loading = true;

    const helper = new JwtHelperService();

    const token = localStorage.getItem('merchant_token');

    if (!token) {
      this.loading = false;
      return;
    }

    const decoded: any = helper.decodeToken(token);

    const merchantId = decoded.id;

    this.authService.getMerchantAnalytics(merchantId).subscribe(

      (res: any) => {

        this.loading = false;

        if (!res.analyticsEnabled) {
          this.analyticsEnabled = false;
          this.analyticsMessage = res.message;
          return;
        }

        const data = res.data;

        this.analyticsCards = [
          // Visibility
          { title: 'Profile Views', value: data.profileViews ?? 0, icon: 'fas fa-eye', color: '#3B82F6' },
          { title: 'Photo Gallery Views', value: data.photoGalleryViews ?? 0, icon: 'fas fa-images', color: '#8B5CF6' },

          // Engagement / Clicks
          { title: 'Website Clicks', value: data.websiteClicks ?? 0, icon: 'fas fa-globe', color: '#10B981' },
          { title: 'Phone Clicks', value: data.phoneClicks ?? 0, icon: 'fas fa-phone', color: '#F59E0B' },
          { title: 'Email Clicks', value: data.emailClicks ?? 0, icon: 'fas fa-envelope', color: '#14B8A6' },
          { title: 'Directions Clicks', value: data.directionsClicks ?? 0, icon: 'fas fa-map-marker-alt', color: '#EF4444' },
          { title: 'App Store Clicks', value: data.appStoreClicks ?? 0, icon: 'fas fa-mobile-alt', color: '#6366F1' },

          // Ratings
          { title: 'Up Ratings', value: data.upratings ?? 0, icon: 'fas fa-thumbs-up', color: '#06B6D4' },
          { title: 'Down Ratings', value: data.downratings ?? 0, icon: 'fas fa-thumbs-down', color: '#EC4899' },

          // Member Discounts
          { title: 'Member Discount Views', value: data.memberDiscountViews ?? 0, icon: 'fas fa-tags', color: '#F97316' },
          { title: 'Member Discount Clicks', value: data.memberDiscountClicks ?? 0, icon: 'fas fa-hand-pointer', color: '#F97316' },

          // Demographics
          { title: 'Male Visitors', value: data.maleVisitors ?? 0, icon: 'fas fa-male', color: '#0891B2' },
          { title: 'Female Visitors', value: data.femaleVisitors ?? 0, icon: 'fas fa-female', color: '#DB2777' },
        ];

      },
      (error: any) => {
        this.loading = false;
        this.authService.successMessage(error.error.message, 'error');
      }

    );

  }

  // NEW
  getInsights() {
    const token = localStorage.getItem('merchant_token');
    if (!token) return;

    const helper = new JwtHelperService();
    const decoded: any = helper.decodeToken(token);
    const merchantId = decoded.id;

    this.authService.getMerchantInsights(merchantId).subscribe(
      (res: any) => {
        if (res.analyticsEnabled) {
          this.insightsData = res.data;
        }
      },
      (error: any) => {
        console.error('Insights fetch failed', error);
      }
    );
  }

}